import { AbstractApiClient } from "../AbstractApiClient/AbstractApiClient";
import { authPushToCardUser } from "./routes/authPushToCardUser/authPushToCardUser";
import { bulkTerminatePaycards } from "./routes/bulkTerminatePaycards/bulkTerminatePaycards";
import { calculateCharges } from "./routes/calculateCharges/calculateCharges";
import { captureFinixTransactions } from "./routes/captureFinixTransactions/captureFinixTransactions";
import { companyAddAch } from "./routes/companyAddAch/companyAddAch";
import { companyKybOnboard } from "./routes/companyKybOnboard/companyKybOnboard";
import { companyOnboard } from "./routes/companyOnboard/companyOnboard";
import { createAppleWalletProvision } from "./routes/createAppleWalletProvision/createAppleWalletProvision";
import { createBankAccount } from "./routes/createBankAccount/createBankAccount";
import { createChargePolicy } from "./routes/createChargePolicy/createChargePolicy";
import { createCustodyNode } from "./routes/createCustodyNode/createCustodyNode";
import { createFinixCard } from "./routes/createFinixCard/createFinixCard";
import { createFinixMerchant } from "./routes/createFinixMerchant/createFinixMerchant";
import { createFinixTransaction } from "./routes/createFinixTransaction/createFinixTransaction";
import { createGoogleWalletProvision } from "./routes/createGoogleWalletProvision/createGoogleWalletProvision";
import { createKybEvaluation } from "./routes/createKybEvaluation/createKybEvaluation";
import { createPayCard } from "./routes/createPayCard/createPayCard";
import { createPayout } from "./routes/createPayout/createPayout";
import { createPushToCardBusiness } from "./routes/createPushToCardBusiness/createPushToCardBusiness";
import { createPushToCardBusinessAccount } from "./routes/createPushToCardBusinessAccount/createPushToCardBusinessAccount";
import { createPushToCardWorker } from "./routes/createPushToCardWorker/createPushToCardWorker";
import { createTransaction } from "./routes/createTransaction/createTransaction";
import { createWallet } from "./routes/createWallet/createWallet";
import { customerAccountAddAch } from "./routes/customerAccountAddAch/customerAccountAddAch";
import { customerAccountOnboard } from "./routes/customerAccountOnboard/customerAccountOnboard";
import { deleteFinixCard } from "./routes/deleteFinixCard/deleteFinixCard";
import { deletePushToCardUserCard } from "./routes/deletePushToCardUserCard/deletePushToCardUserCard";
import { generateTransactionEvents } from "./routes/generateTransactionEvents/generateTransactionEvents";
import { getAllPaycards } from "./routes/getAllPaycards/getAllPaycards";
import { getAstraAccountBalance } from "./routes/getAstraAccountBalance/getAstraAccountBalance";
import { getCardInfo } from "./routes/getCardInfo/getCardInfo";
import { getChargePolicy } from "./routes/getChargePolicy/getChargePolicy";
import { getCharge } from "./routes/getCharges/getCharge";
import { getBusinessCards } from "./routes/getBusinessCards/getBusinessCards";
import { getCompanies } from "./routes/getCompany/getCompanies";
import { getCompany } from "./routes/getCompany/getCompany";
import { getCompanyAccounts } from "./routes/getCompanyAccounts/getCompanyAccounts";
import { getCompanyCardProducts } from "./routes/getCompanyCardProducts/getCompanyCardProducts";
import { getCompanyMicroDeposits } from "./routes/getCompanyMicroDeposits/getCompanyMicroDeposits";
import { getCompanyStatus } from "./routes/getCompanyStatus/getCompanyStatus";
import { getCustomerAccountMicroDeposits } from "./routes/getCustomerAccountMicroDeposits/getCustomerAccountMicroDeposits";
import { getEmployeeWatchlistStatus } from "./routes/getEmployeeWatchlistStatus/getEmployeeWatchlistStatus";
import { getFinixCards } from "./routes/getFinixCards/getFinixCards";
import { getFinixInfo } from "./routes/getFinixInfo/getFinixInfo";
import { getFinixMerchant } from "./routes/getFinixMerchant/getFinixMerchant";
import { handleFinixWebhooks } from "./routes/handleFinixWebhooks/handleFinixWebhooks";
import { getLedgerForUser } from "./routes/getLedgerForUser/getLedgerForUser";
import { getPayCards } from "./routes/getPayCards/getPayCards";
import { getPaycardStatement } from "./routes/getPaycardStatement/getPaycardStatement";
import { getPaycardStatements } from "./routes/getPaycardStatements/getPaycardStatements";
import { getPaycardStatistics } from "./routes/getPaycardStatistics/getPaycardStatistics";
import { getPayCardToken } from "./routes/getPayCardToken/getPayCardToken";
import { getPayCardTransaction } from "./routes/getPaycardTransaction/getPaycardTransaction";
import { getPayCardTransactions } from "./routes/getPayCardTransactions/getPayCardTransactions";
import { getPaymentDestinations } from "./routes/getPaymentDestinations/getPaymentDestinations";
import { getPayout } from "./routes/getPayouts/getPayout";
import { getPendingTopUps } from "./routes/getPendingTopUps/getPendingTopUps";
import { getPushToCardCards } from "./routes/getPushToCardCards/getPushToCardCards";
import { getPushToCardWorker } from "./routes/getPushToCardWorker/getPushToCardWorker";
import { getSingleCardInfo } from "./routes/getSingleCardInfo/getSingleCardInfo";
import { getStateAgencyInfo } from "./routes/getStateAgencyInfo/getStateAgencyInfo";
import { getStateAgencyTransactionsBulk } from "./routes/getStateAgencyTransactionsBulk/getStateAgencyTransactionsBulk";
import { getTransactionEvents } from "./routes/getTransactionEvents/getTransactionEvents";
import { getTransactionRecord } from "./routes/getTransactionRecord/getTransactionRecord";
import { getTransactions } from "./routes/getTransactions/getTransactions";
import { getTransactionStatus } from "./routes/getTransactionStatus/getTransactionStatus";
import { getUserData } from "./routes/getUserData/getUserData";
import { getWallets } from "./routes/getWallets/getWallets";
import { getWalletStatistics } from "./routes/getWalletStatistics/getWalletStatistics";
import { getWalletTransaction } from "./routes/getWalletTransaction/getWalletTransaction";
import { getWalletTransactions } from "./routes/getWalletTransactions/getWalletTransactions";
import { listAccountBalances } from "./routes/listAccountBalances/listAccountBalances";
import { migrateOneCompany } from "./routes/migrateCompanies/migrateOneCompany";
import { getUnmigratedWorkers } from "./routes/migrateWorkers/getUnmigratedWorkers";
import { migrateOneWorker } from "./routes/migrateWorkers/migrateOneWorker";
import { onboardEmployee } from "./routes/onboardEmployee/onboardEmployee";
import { reconcileBankAccounts } from "./routes/reconcileBankAccounts/reconcileBankAccounts";
import { resetCompanyMicroDeposits } from "./routes/resetCompanyMicroDeposits/resetCompanyMicroDeposits";
import { runAllKYC } from "./routes/runAllKYC/runAllKYC";
import { runCompanyKYB } from "./routes/runCompanyKYB/runCompanyKYB";
import { runKYC } from "./routes/runKYC/runKYC";
import { runSSNVerification } from "./routes/runSSNVerification/runSSNVerification";
import { triggerCompanyMicroDeposits } from "./routes/triggerCompanyMicroDeposits/triggerCompanyMicroDeposits";
import { triggerCustomerAccountMicroDeposits } from "./routes/triggerCustomerAccountMicroDeposits/triggerCustomerAccountMicroDeposits";
import { updateBankAccount } from "./routes/updateBankAccount/updateBankAccount";
import { updateBusinessCards } from "./routes/updateBusinessCards/updateBusinessCards";
import { updateChargePolicy } from "./routes/updateChargePolicy/updateChargePolicy";
import { updateComplianceForm } from "./routes/updateComplianceForm/updateComplianceForm";
import { updateCompanyNode } from "./routes/updateCompanyNode/updateCompanyNode";
import { updateKYCInfo } from "./routes/updateKYCInfo/updateKYCInfo";
import { updatePaycard } from "./routes/updatePaycard/updatePaycard";
import { updatePushToCardUserCard } from "./routes/updatePushToCardUserCard/updatePushToCardUserCard";
import { updatePushToCardWorker } from "./routes/updatePushToCardWorker/updatePushToCardWorker";
import { updateTransactionStatuses } from "./routes/updateTransactionStatuses/updateTransactionStatuses";
import { voidTransaction } from "./routes/voidTransaction/voidTransaction";
import { verifyCompanyMicroDeposits } from "./routes/verifyCompanyMicroDeposits/verifyCompanyMicroDeposits";
import { verifyCustomerAccountMicroDeposits } from "./routes/verifyCustomerAccountMicroDeposits/verifyCustomerAccountMicroDeposits";
import { verifyRoutingNumber } from "./routes/verifyRoutingNumber/verifyRoutingNumber";
import {
  assertValidOdoSchema,
  OdoSchemaAssertionWithParams,
} from "./validation-types/assertValidOdoSchema";
import { updateCheckbookUsersFirstAndLastNames } from "./routes/updateCheckbookUsersFirstAndLastNames/updateCheckbookUsersFirstAndLastNames";
import { companyAddDepositAccounts } from "./routes/companyAddDepositAccounts/companyAddDepositAccounts";

export class OdoClient extends AbstractApiClient {
  public static AssertValidSchema: OdoSchemaAssertionWithParams =
    assertValidOdoSchema;
  public readonly AuthPushToCardUser = authPushToCardUser(this.Instance);
  public readonly CalculateCharges = calculateCharges(this.Instance);
  public readonly CaptureFinixTransactions = captureFinixTransactions(
    this.Instance
  );
  public readonly CompanyAddAch = companyAddAch(this.Instance);
  public readonly CompanyAddDepositAccounts = companyAddDepositAccounts(
    this.Instance
  );
  public readonly CompanyOnboard = companyOnboard(this.Instance);
  public readonly CompanyKybOnboard = companyKybOnboard(this.Instance);
  public readonly CreateBankAccount = createBankAccount(this.Instance);
  public readonly CreateCustodyNode = createCustodyNode(this.Instance);
  public readonly CreateKybEvaluation = createKybEvaluation(this.Instance);
  public readonly CreatePayCard = createPayCard(this.Instance);
  public readonly CreateChargePolicy = createChargePolicy(this.Instance);
  public readonly CreateFinixCard = createFinixCard(this.Instance);
  public readonly CreateFinixMerchant = createFinixMerchant(this.Instance);
  public readonly CreateFinixTransaction = createFinixTransaction(
    this.Instance
  );
  public readonly CreatePayout = createPayout(this.Instance);
  public readonly CreatePushToCardBusiness = createPushToCardBusiness(
    this.Instance
  );
  public readonly CreatePushToCardBusinessAccount =
    createPushToCardBusinessAccount(this.Instance);
  public readonly CreatePushToCardWorker = createPushToCardWorker(
    this.Instance
  );
  public readonly CreateTransaction = createTransaction(this.Instance);
  public readonly CreateWallet = createWallet(this.Instance);
  public readonly CustomerAccountAddAch = customerAccountAddAch(this.Instance);
  public readonly CustomerAccountOnboard = customerAccountOnboard(
    this.Instance
  );
  public readonly DeleteFinixCard = deleteFinixCard(this.Instance);
  public readonly DeletePushToCardUserCard = deletePushToCardUserCard(
    this.Instance
  );
  public readonly GenerateTransactionEvents = generateTransactionEvents(
    this.Instance
  );
  public readonly GetAllPaycards = getAllPaycards(this.Instance);
  public readonly GetAstraAccountBalance = getAstraAccountBalance(
    this.Instance
  );
  public readonly GetCardInfo = getCardInfo(this.Instance);
  public readonly GetChargePolicy = getChargePolicy(this.Instance);
  public readonly GetBusinessCards = getBusinessCards(this.Instance);
  public readonly GetCharge = getCharge(this.Instance);
  public readonly GetCompanies = getCompanies(this.Instance);
  public readonly GetCompany = getCompany(this.Instance);
  public readonly GetCompanyAccounts = getCompanyAccounts(this.Instance);
  public readonly GetCompanyCardProducts = getCompanyCardProducts(
    this.Instance
  );
  public readonly GetCompanyMicroDeposits = getCompanyMicroDeposits(
    this.Instance
  );
  public readonly GetCompanyStatus = getCompanyStatus(this.Instance);
  public readonly GetCustomerAccountMicroDeposits =
    getCustomerAccountMicroDeposits(this.Instance);
  public readonly GetEmployeeWatchlistStatus = getEmployeeWatchlistStatus(
    this.Instance
  );
  public readonly GetFinixCards = getFinixCards(this.Instance);
  public readonly GetFinixInfo = getFinixInfo(this.Instance);
  public readonly GetFinixMerchant = getFinixMerchant(this.Instance);
  public readonly HandleFinixWebhooks = handleFinixWebhooks(this.Instance);
  public readonly GetLedgerForUser = getLedgerForUser(this.Instance);
  public readonly GetPayCards = getPayCards(this.Instance);
  public readonly GetPaycardStatement = getPaycardStatement(this.Instance);
  public readonly GetPaycardStatements = getPaycardStatements(this.Instance);
  public readonly GetPaycardStatistics = getPaycardStatistics(this.Instance);
  public readonly GetPayCardToken = getPayCardToken(this.Instance);
  public readonly GetPayCardTransaction = getPayCardTransaction(this.Instance);
  public readonly GetPayCardTransactions = getPayCardTransactions(
    this.Instance
  );
  public readonly CreateAppleWalletProvision = createAppleWalletProvision(
    this.Instance
  );
  public readonly CreateGoogleWalletProvision = createGoogleWalletProvision(
    this.Instance
  );
  public readonly GetPayout = getPayout(this.Instance);
  public readonly GetPaymentDestinations = getPaymentDestinations(
    this.Instance
  );
  public readonly GetPendingTopUps = getPendingTopUps(this.Instance);
  public readonly GetPushToCardCards = getPushToCardCards(this.Instance);
  public readonly GetPushToCardWorker = getPushToCardWorker(this.Instance);
  public readonly GetSingleCardInfo = getSingleCardInfo(this.Instance);
  public readonly GetStateAgencyInfo = getStateAgencyInfo(this.Instance);
  public readonly GetStateAgencyTransactionsBulk =
    getStateAgencyTransactionsBulk(this.Instance);
  public readonly GetTransactionEvents = getTransactionEvents(this.Instance);
  public readonly GetTransactionRecord = getTransactionRecord(this.Instance);
  public readonly GetTransactions = getTransactions(this.Instance);
  public readonly GetTransactionStatus = getTransactionStatus(this.Instance);
  public readonly GetUnmigratedWorkers = getUnmigratedWorkers(this.Instance);
  public readonly GetUserData = getUserData(this.Instance);
  public readonly GetWallets = getWallets(this.Instance);
  public readonly GetWalletStatistics = getWalletStatistics(this.Instance);
  public readonly GetWalletTransaction = getWalletTransaction(this.Instance);
  public readonly GetWalletTransactions = getWalletTransactions(this.Instance);
  public readonly ListAccountBalances = listAccountBalances(this.Instance);
  public readonly MigrateOneCompany = migrateOneCompany(this.Instance);
  public readonly MigrateOneWorker = migrateOneWorker(this.Instance);
  public readonly OnboardEmployee = onboardEmployee(this.Instance);
  public readonly ReconcileBankAccounts = reconcileBankAccounts(this.Instance);
  public readonly ResetCompanyMicroDeposits = resetCompanyMicroDeposits(
    this.Instance
  );
  public readonly RunAllKYC = runAllKYC(this.Instance);
  public readonly RunCompanyKYB = runCompanyKYB(this.Instance);
  public readonly RunKYC = runKYC(this.Instance);
  public readonly RunSSNVerification = runSSNVerification(this.Instance);
  public readonly TriggerCompanyMicroDeposits = triggerCompanyMicroDeposits(
    this.Instance
  );
  public readonly TriggerCustomerAccountMicroDeposits =
    triggerCustomerAccountMicroDeposits(this.Instance);
  public readonly UpdateBankAccount = updateBankAccount(this.Instance);
  public readonly UpdateCompanyNode = updateCompanyNode(this.Instance);
  public readonly UpdateKYCInfo = updateKYCInfo(this.Instance);
  public readonly UpdatePaycard = updatePaycard(this.Instance);
  public readonly UpdateBusinessCards = updateBusinessCards(this.Instance);
  public readonly UpdateChargePolicy = updateChargePolicy(this.Instance);
  public readonly UpdateComplianceForm = updateComplianceForm(this.Instance);
  public readonly UpdateTransactionStatuses = updateTransactionStatuses(
    this.Instance
  );
  public readonly UpdatePushToCardWorker = updatePushToCardWorker(
    this.Instance
  );
  public readonly VoidTransaction = voidTransaction(this.Instance);
  public readonly VerifyCompanyMicroDeposits = verifyCompanyMicroDeposits(
    this.Instance
  );
  public readonly VerifyCustomerAccountMicroDeposits =
    verifyCustomerAccountMicroDeposits(this.Instance);

  public readonly VerifyRoutingNumber = verifyRoutingNumber(this.Instance);
  public readonly UpdatePushToCardUserCard = updatePushToCardUserCard(
    this.Instance
  );
  public readonly BulkTerminatePaycards = bulkTerminatePaycards(this.Instance);
  public readonly UpdateCheckbookUsersFirstAndLastNames =
    updateCheckbookUsersFirstAndLastNames(this.Instance);
}
